import { Link } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';

const siteUrl = import.meta.env.VITE_SITE_URL || '';

const jsonLd = {
  '@context': 'https://schema.org',
  '@type': 'Article',
  headline: 'Itaobuy Spreadsheet Sneakers: Guida alle Migliori Scarpe 2026',
  url: `${siteUrl}/itaobuy-spreadsheet-sneakers`,
  description: 'Scopri le migliori sneakers su itaobuy spreadsheet: modelli esclusivi, edizioni limitate e scarpe di tendenza a prezzi competitivi.',
  inLanguage: 'it',
  datePublished: '2026-07-14',
  dateModified: '2026-07-14',
  author: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
  publisher: { '@type': 'Organization', name: 'Itaobuy Spreadsheet' },
};

export default function SneakersPage() {
  return (
    <div className="min-h-screen bg-background-50">
      <JsonLd data={jsonLd} />
      <Navbar />
      <main>
        <header className="bg-foreground-950 pt-24 pb-16 md:pt-32 md:pb-20">
          <div className="max-w-3xl mx-auto px-4 md:px-6">
            <span className="inline-block font-label text-xs uppercase tracking-[0.2em] text-accent-400 bg-accent-500/10 px-3 py-1 rounded-md mb-5">/ SNEAKERS</span>
            <h1 className="font-heading text-3xl md:text-4xl lg:text-5xl font-bold text-background-50 leading-tight mb-5">
              Itaobuy Spreadsheet Sneakers: Guida alle Migliori Scarpe 2026
            </h1>
            <p className="text-background-50/70 text-sm md:text-base">Scopri le <strong className="text-background-50">migliori sneakers su itaobuy spreadsheet</strong>: modelli esclusivi, edizioni limitate e scarpe di tendenza a prezzi competitivi.</p>
          </div>
        </header>

        <article className="max-w-3xl mx-auto px-4 md:px-6 py-12 md:py-16">
          <div className="space-y-8 text-foreground-700 leading-relaxed">
            <div className="bg-background-100 rounded-2xl p-6 md:p-8">
              <p className="text-sm text-foreground-600">Torna alla <Link to="/" className="text-primary-600 font-medium hover:underline">homepage</Link> per tutte le categorie, oppure visita direttamente la <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="text-primary-600 font-medium hover:underline">categoria Shoes</a>.</p>
            </div>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Perché le Sneakers Sono la Categoria Più Popolare</h2>
              <p className="mb-4">La categoria <strong className="text-foreground-950">sneakers su itaobuy spreadsheet</strong> è la più visitata dagli utenti italiani, e non è difficile capire perché. Dalle iconiche silhouette retrò alle collaborazioni esclusive più ricercate, il database raccoglie centinaia di modelli con foto dettagliate, recensioni e link diretti per l'acquisto.</p>
              <p>Che tu stia cercando scarpe running, casual o modelli限量, il <strong className="text-foreground-950">database itaobuy</strong> ti offre una selezione curata e aggiornata. Consulta anche la <Link to="/guida-itaobuy-spreadsheet-italiano" className="text-primary-600 font-medium hover:underline">guida completa</Link> per consigli generali sullo shopping.</p>
            </section>
            <section>
              <h2 className="font-heading text-2xl font-bold text-foreground-950 mb-4">Come Scegliere la Taglia Giusta</h2>
              <p className="mb-4">Uno degli aspetti più critici nell'acquisto di sneakers è la scelta della taglia. Il consiglio è di consultare sempre le tabelle delle misure fornite nel database e leggere le recensioni di altri utenti che hanno già acquistato lo stesso modello. Le <strong className="text-foreground-950">foto QC</strong> sono fondamentali anche per verificare la qualità delle cuciture e dei materiali.</p>
              <p>Per approfondire, leggi la <Link to="/itaobuy-qc-photos" className="text-primary-600 font-medium hover:underline">guida alle QC Photos</Link>.</p>
            </section>

            <div className="bg-primary-50 border border-primary-200 rounded-2xl p-6 md:p-8 my-10">
              <h3 className="font-heading text-xl font-bold text-foreground-950 mb-3">Trova le Tue Sneakers Ideali</h3>
              <p className="text-sm text-foreground-600 mb-5">Sfoglia la categoria completa delle scarpe nel nostro database.</p>
              <a href="https://kaspreadsheet.com/category-911-Shoes.html" target="_blank" rel="noopener nofollow" className="inline-flex items-center gap-2 px-6 py-3 rounded-full text-sm font-semibold bg-primary-500 text-background-50 hover:bg-primary-600 transition-all">
                Vai alle Shoes <i className="ri-arrow-right-line"></i>
              </a>
            </div>
            <footer className="border-t border-background-200 pt-8 mt-12">
              <p className="text-xs text-foreground-400"><strong className="text-foreground-500">Itaobuy spreadsheet sneakers</strong> — <Link to="/" className="text-primary-600 hover:underline">Torna alla home</Link>.</p>
            </footer>
          </div>
        </article>
      </main>
      <Footer />
    </div>
  );
}